/** 省市区选择控件 @author lincl */
<template>
    <div class="cl-area-cascader">
        <el-cascader
                :placeholder="placeholder"
                :disabled="disabled"
                :props="props"
                :options="options"
                :collapse-tags="collapseTags"
                v-model="vModel"
                filterable
                clearable
                @change="handleChange"
        ></el-cascader>
    </div>
</template>

<script>
import {getCache} from '@/utils/cache'
import {getRegion, split} from '@/utils'

export default {
    name: 'AreaCascader',
    props: {
        value: {
            type: String,
            required: false,
            default: ''
        },
        // 父节点Id，只选该节点下的数据
        parentId: {
            type: String,
            required: false,
            default: ''
        },
        placeholder: {
            type: String,
            required: false,
            default: '请选择'
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },
        // 是否严格的遵守父子节点不互相关联。false：必须选到最后一级，true：可以不选择到最后一级
        checkStrictly: {
            type: Boolean,
            required: false,
            default: false
        },
        // 是否多选
        multiple: {
            type: Boolean,
            required: false,
            default: false
        },
        // 多选模式下是否折叠Tag
        collapseTags: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    created() {
        this.initModel()
        this.initData()
    },
    data() {
        return {
            vModel: null,
            result: null,
            options: [],
            props: {
                checkStrictly: this.checkStrictly,
                multiple: this.multiple,
                expandTrigger: true,
                value: 'id',
                label: 'name'
            }
        }
    },
    watch: {
        value: function (val, oldVal) {
            if (!this.result || (this.result && val !== this.result.join())) {
                this.result = []
                this.initModel()
            }
        },
        parentId: function () {
            this.initData()
        }
    },
    methods: {
        /**
         * 初始化选中
         */
        initModel() {
            if (!this.multiple) {
                const arr = getRegion(this.value)
                if (arr != null) {
                    if (arr[0] == null) {
                        this.vModel = null
                    } else if (arr[1] == null) {
                        this.vModel = [arr[0]]
                    } else if (arr[2] == null) {
                        this.vModel = [arr[0], arr[1]]
                    } else {
                        this.vModel = arr
                    }
                } else {
                    this.vModel = null
                }
                return
            }
            const arr = split(this.value)
            const parentIsProvince = this.parentId.endsWith('0000')
            const parentIsCity = !parentIsProvince && this.parentId.endsWith('00')
            this.vModel = []
            for (let i = 0; i < arr.length; i++) {
                const item = arr[i]
                if (item.endsWith('0000')) {
                    // 省
                    this.vModel.push([item])
                } else if (item.endsWith('00')) {
                    // 市
                    if (parentIsProvince) {
                        // 指定省，存入：市
                        this.vModel.push([item])
                    } else {
                        // 存入：市-》区
                        this.vModel.push([item.substr(0, 2) + '0000', item])
                    }
                } else {
                    // 区
                    if (parentIsProvince) {
                        // 指定省，存入：市-》区
                        this.vModel.push([item.substr(0, 4) + '00', item])
                    } else if (parentIsCity) {
                        // 指定市，存入：区
                        this.vModel.push([item])
                    } else {
                        // 存入：省-》市-》区
                        this.vModel.push([item.substr(0, 2) + '0000', item.substr(0, 4) + '00', item])
                    }
                }
            }
        },
        /**
         * 初始化数据
         */
        initData() {
            getCache('region', 'all', '/region/list/tree', {}).then(res => {
                if (!this.parentId) {
                    this.options = res
                } else {
                    const str = this.parentId + ''
                    if (str.endsWith('0000')) {
                        // 指定省
                        const province = this.getItem(str, res)
                        this.options = province.children
                    } else if (str.endsWith('00')) {
                        // 指定市
                        const province = this.getItem(str.substr(0, 2) + '0000', res)
                        const city = this.getItem(str, province.children)
                        this.options = city.children
                    }
                }
            })
        },
        /**
         * 从数组中查找
         * @param value
         * @param data
         * @returns {null|*}
         */
        getItem(value, data) {
            for (let i = 0; i < data.length; i++) {
                if (value === data[i].id) {
                    return data[i]
                }
            }
            return null
        },
        /**
         * change事件回调
         * @param data
         */
        handleChange(data) {
            this.result = []
            if (data.length > 0) {
                if (this.multiple) {
                    // 多选
                    for (let i = 0; i < data.length; i++) {
                        const item = data[i]
                        this.result.push(item[item.length - 1])
                    }
                } else {
                    // 单选
                    this.result.push(data[data.length - 1])
                }
                this.$emit('input', this.result.join())
                this.$emit('change', Object.assign({}, data))
            } else {
                this.$emit('input', null)
                this.$emit('change', Object.assign({}, data))
            }
        }
    }
}
</script>
<style scoped></style>
